<!---------------------------->
<!-- MemberPolicyProductLinkComponent:-->
<!---------------------------->

@if (enableSearchInputs) {
  <!-- Row-1-->
  <mat-grid-list cols="3" rowHeight="75px">
    <mat-grid-tile class="selection_align">
      <div class="member-or-policy-radio-group">
        <mat-radio-group [name]="'memberOrMembershipRadioGroup'"
                         [formControl]="memberOrMembershipFormControl"
                         (change)="onMemberOrMembershipRadioOptionValueChanged($event)">
          <mat-radio-button class="m-b-5" [value]="searchType.Membership">
            {{searchType.Membership}}
          </mat-radio-button>
          <mat-radio-button class="m-b-5" [value]="searchType.Member">
            {{searchType.Member}}
          </mat-radio-button>
        </mat-radio-group>
      </div>

      <!-- Membership Dropdown List -->
      @if (memberOrMembershipFormControl.value === searchType.Member) {
        <mat-form-field class="membership-search-field">
          <mat-label>Membership</mat-label>
          <mat-select [formControl]="membershipFormControl" required
                      (selectionChange)="onMembershipSelected($event.source.value)">
            <mat-option *ngFor="let membership of filteredMemberships" [value]="getMembershipDisplayString(membership)">
              {{filteredMemberships.length > 1 ? getMembershipDisplayStringWithDates(membership) : getMembershipDisplayString(membership)}}
            </mat-option>
          </mat-select>
          @if (membershipFormControl.value) {
            <button aria-label="Clear" mat-button mat-icon-button matSuffix
                    (click)="resetLinkedMembershipsAndProducts()">
              <mat-icon style="color: grey;">clear</mat-icon>
            </button>
          }
        </mat-form-field>
      }

      <!-- Membership Number Autocomplete -->
      @if (memberOrMembershipFormControl.value === searchType.Membership) {
        <mat-form-field class="membership-search-field">
          <mat-label>Membership Number</mat-label>
          <input required matInput type="text"
                 [placeholder]="getInfoTooltip('Membership Number')"
                 [formControl]="membershipFormControl"
                 (input)="membershipNumberTextChanged$.next($any($event.target).value)"
                 (blur)="onBlurMembershipNumber()"
                 [matAutocomplete]="membershipAuto">
          <mat-autocomplete #membershipAuto="matAutocomplete" [panelWidth]="'40vw'">
            <mat-option (onSelectionChange)="onMembershipSelected($event.source.value)"
                        *ngFor="let membership of filteredMemberships"
                        [value]="getMembershipDisplayString(membership)"
                        class="custom-mat-option">
              {{filteredMemberships.length > 1 ? getMembershipDisplayStringWithDates(membership) : getMembershipDisplayString(membership)}}
            </mat-option>
          </mat-autocomplete>
          @if (membershipFormControl.value) {
            <button aria-label="Clear"
                    mat-button mat-icon-button matSuffix
                    (click)="resetDependentLinkedInsuredPersonsMembershipsAndProducts()">
              <mat-icon style="color: grey;">clear</mat-icon>
            </button>
          }
        </mat-form-field>
      }

      @if (memberOrMembershipFormControl.value === searchType.Member) {
        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Membership Number')">help_outline</mat-icon>
      } @else {
        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Member Drop Down')">help_outline</mat-icon>
      }

    </mat-grid-tile>

    <mat-grid-tile class="selection_align">
      <!-- Member Autocomplete -->
      @if (memberOrMembershipFormControl.value === searchType.Member) {
        <mat-form-field>
          <mat-label>Member</mat-label>
          <input required matInput type="text"
                 [placeholder]="getInfoTooltip('Member Details Search')"
                 [formControl]="insuredPersonNameFormControl"
                 (input)="insuredPersonNameTextChanged$.next($any($event.target).value)"
                 (blur)="onBlurInsuredPersonName()"
                 [matAutocomplete]="insuredPersonAuto">
          <mat-autocomplete #insuredPersonAuto="matAutocomplete" [panelWidth]="'40vw'">
            <mat-option (onSelectionChange)="onInsuredPersonSelected($event.source.value)"
                        *ngFor="let insuredPerson of filteredInsuredPersons"
                        [value]="insuredPerson.displayValue"
                        class="custom-mat-option">
              {{insuredPerson.displayValue}}
            </mat-option>
          </mat-autocomplete>
          @if (insuredPersonNameFormControl.value) {
            <button aria-label="Clear"
                    mat-button mat-icon-button matSuffix
                    (click)="resetDependentLinkedInsuredPersonsMembershipsAndProducts()">
              <mat-icon style="color: grey;">clear</mat-icon>
            </button>
          }
        </mat-form-field>
      }

      <!-- Member Dropdown List -->
      @if (memberOrMembershipFormControl.value === searchType.Membership) {
        <mat-form-field>
          <mat-label>Member</mat-label>
          <mat-select [formControl]="insuredPersonNameFormControl" required
                      (selectionChange)="onInsuredPersonSelected($event.source.value)">
            <mat-option *ngFor="let insuredPerson of filteredInsuredPersons"
                        [value]="insuredPerson.displayValue">
              {{insuredPerson.displayValue}}
            </mat-option>
          </mat-select>
          @if (insuredPersonNameFormControl.value) {
            <button (click)="clearInsuredPersonName(); clearProduct();"
                    aria-label="Clear"
                    mat-button mat-icon-button matSuffix>
              <mat-icon style="color: grey;">clear</mat-icon>
            </button>
          }
        </mat-form-field>
      }
      <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Member Drop Down')">help_outline</mat-icon>
    </mat-grid-tile>

    <!--Products not exists -->
    @if (isPersonAndMembershipSelected && !hasProducts) {
      <mat-grid-tile class="selection_align">
        <mat-label class="mat-primary-color">No {{type}} products are associated to this policy</mat-label>
      </mat-grid-tile>
    } @else {
      <mat-grid-tile class="selection_align">
        <mat-form-field>
          <mat-label>Product</mat-label>
          <mat-select [formControl]="productFormControl" required
                      (selectionChange)="onProductSelected($event.source.value)">
            <mat-option *ngFor="let product of products" [value]="product.productId">
              {{products.length > 1 ? getProductDisplayName(product) : product.name}}
            </mat-option>
          </mat-select>
          @if (productFormControl.value) {
            <button aria-label="Clear"
                    mat-button mat-icon-button matSuffix
                    (click)="clearProduct()">
              <mat-icon style="color: grey;">clear</mat-icon>
            </button>
          }
        </mat-form-field>
        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Product Name')">help_outline</mat-icon>
      </mat-grid-tile>
    }
  </mat-grid-list>
}

<!--Row-1-->

<mat-grid-list cols="3" rowHeight="75px">

  <mat-grid-tile>
    @if (selectedPolicy) {
      <app-content-field [content]="selectedPolicy.name"
                         [label]="'Policy Name'"></app-content-field>
    }
  </mat-grid-tile>

  <mat-grid-tile>

    <ng-container *ngTemplateOutlet="memberNameTpl || defaultMemberNameTpl;"></ng-container>

    <ng-template #defaultMemberNameTpl>
      @if (selectedInsuredPerson) {
        <app-content-field [content]="getInsuredPersonNameDisplayString(selectedInsuredPerson)"
                           [label]="'Member Name'">
        </app-content-field>
      }
    </ng-template>
  </mat-grid-tile>

  @if (isPersonAndMembershipSelected) {
    <mat-grid-tile>
      @if (selectedProduct) {
        <app-content-field [content]="selectedProduct.name"
                           [label]="'Product Name'"></app-content-field>
      }
    </mat-grid-tile>
  }

</mat-grid-list>

<!--Row-2-->

<mat-grid-list cols="3" rowHeight="75px">

  <mat-grid-tile>
    @if (selectedPolicy) {
      <app-content-field [content]="selectedPolicy.number"
                         [label]="'Membership Number'"></app-content-field>
    }
  </mat-grid-tile>

  <mat-grid-tile>
    @if (selectedInsuredPerson) {
      <app-content-field [content]="selectedInsuredPerson.cardNumber"
                         [label]="'Member Number'"></app-content-field>
    }
  </mat-grid-tile>

  @if (isPersonAndMembershipSelected) {
    <mat-grid-tile>
      @if (selectedProduct) {
        <app-content-field [content]="selectedProduct.productCode"
                           [label]="'Product Code'"></app-content-field>
      }
    </mat-grid-tile>
  }

</mat-grid-list>

<!--Row-3-->

<mat-grid-list cols="3" rowHeight="75px">


  <mat-grid-tile>
    @if (selectedPolicy) {
      <app-content-field [content]="selectedPolicy.policyholder.name"
                         [label]="'Policyholder'"></app-content-field>
    }
  </mat-grid-tile>

  <mat-grid-tile>
    <ng-container *ngTemplateOutlet="memberAssociationTpl || defaultMemberAssociationTpl;"></ng-container>

    <ng-template #defaultMemberAssociationTpl>
      @if (selectedInsuredPerson) {
        <app-content-field [content]="getAssociationDisplayString(selectedInsuredPerson)"
                           [label]="'Member Association'"></app-content-field>
      }
    </ng-template>
  </mat-grid-tile>

  @if (isPersonAndMembershipSelected) {
    <mat-grid-tile>
      @if (selectedProduct) {
        <app-content-field [content]="selectedProduct.processingClass.name"
                           [label]="'Processing Class'"></app-content-field>
      }
    </mat-grid-tile>
  }

</mat-grid-list>

<!--Row-4-->

<mat-grid-list cols="3" rowHeight="75px">
  <mat-grid-tile>
    @if (selectedPolicy) {
      <app-content-field [content]="selectedPolicy.administrator?.name"
                         [label]="'Administrator'"></app-content-field>
    }
  </mat-grid-tile>

  <mat-grid-tile>
    <ng-container *ngTemplateOutlet="dateOfBirthTpl || defaultDateOfBirthTpl;"></ng-container>

    <ng-template #defaultDateOfBirthTpl>
      @if (selectedInsuredPerson) {
        <app-content-field [content]="selectedInsuredPerson.dateOfBirth | date: dateFormat"
                           [label]="'Date of Birth'"></app-content-field>
      }
    </ng-template>
  </mat-grid-tile>

  @if (isPersonAndMembershipSelected) {
    <mat-grid-tile>
      @if (selectedProduct) {
        <app-content-field [content]="selectedProduct.bookingDays"
                           [label]="'Booking Days'"></app-content-field>
      }
    </mat-grid-tile>
  }

</mat-grid-list>

<!--Row-5-->
<mat-grid-list cols="3" rowHeight="75px">


  <mat-grid-tile>
    @if (selectedPolicy) {
      <app-content-field [content]="selectedPolicy.payer.name"
                         [label]="'Payer Name'"></app-content-field>
    }
  </mat-grid-tile>

  <mat-grid-tile>
    <ng-container *ngTemplateOutlet="genderTpl || defaultGenderTpl;"></ng-container>

    <ng-template #defaultGenderTpl>
      @if (selectedInsuredPerson) {
        <app-content-field [content]="selectedInsuredPerson.gender.name"
                           [label]="'Gender'"></app-content-field>
      }
    </ng-template>
  </mat-grid-tile>

  @if (isPersonAndMembershipSelected) {
    <mat-grid-tile>
      @if (selectedProduct) {
        <app-content-field [content]="selectedProduct.providerNetwork.name"
                           [label]="'Provider Network'"></app-content-field>
      }
    </mat-grid-tile>
  }

</mat-grid-list>

<!--Row-6-->

<mat-grid-list cols="3" rowHeight="75px">


  <mat-grid-tile>
    @if (selectedPolicy) {
      <app-content-field [content]="createDateRangeString(selectedPolicy.startDate, selectedPolicy.endDate)"
                         [label]="'Policy Start - End Dates'">
      </app-content-field>
    }
  </mat-grid-tile>

  <mat-grid-tile>
    @if (selectedInsuredPersonWithDates) {
      <app-content-field [content]="createDateRangeString(selectedInsuredPersonWithDates.startDate, selectedInsuredPersonWithDates.endDate)"
                         [label]="'Member Start - End Dates for Selected Policy'">
      </app-content-field>
    }
  </mat-grid-tile>

  @if (isPersonAndMembershipSelected) {
    <mat-grid-tile>
      @if (selectedProduct) {
        <app-content-field [content]="createDateRangeString(selectedProduct.startDate, selectedProduct.endDate)"
                           [label]="'Product Start - End Dates'">
        </app-content-field>
      }
    </mat-grid-tile>
  }
</mat-grid-list>

<!--Row-7-->

<mat-grid-list cols="3" rowHeight="75px">

  <mat-grid-tile>
    @if (selectedPolicy) {
      <app-content-field [content]="selectedPolicy.status"
                         [label]="'Current Policy Cover Status'"></app-content-field>
    }
  </mat-grid-tile>

  <mat-grid-tile>
    @if (selectedInsuredPersonWithDates) {
      <app-content-field [content]="selectedInsuredPersonWithDates.coverStatus?.name || ''"
                         [label]="'Current Member Cover Status'"></app-content-field>
    }
  </mat-grid-tile>
</mat-grid-list>


<!--Row-8-->
<mat-grid-list cols="3" rowHeight="75px">

  <mat-grid-tile>
    <ng-container *ngTemplateOutlet="nationalIDTpl;"></ng-container>
  </mat-grid-tile>

</mat-grid-list>
